import styled from "styled-components";

export const ErrorMessage = styled.p`
    color: #fca5a5;
    font-weight: 600;
    font-size: 0.85rem;
    border: 1px solid rgba(239, 68, 68, 0.25);
    background: rgba(239, 68, 68, 0.1);
    padding: 0.7rem 1rem;
    border-radius: 12px;
    margin-bottom: 0.8rem;
    text-align: center;
    word-wrap: break-word;
    width: 100%;
    max-width: 280px;
    line-height: 1.5;
`;
